import React, { useState, useMemo, useEffect } from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import {
  Flex,
  FlexItem,
  Text,
  TEXT_VARIANT_LIGHT,
  Button,
  BUTTON_VARIANT_PRIMARY,
  Select,
  FormElement,
  ChipCheckbox
} from 'mailup-web-components'
import { StyledLabel } from '../../SelectRecipient'

export const SelectGroup = ({
  groups,
  lastGroups,
  searchRecipientsCallback
}) => {
  const intl = useIntl()
  const [group, setGroup] = useState(undefined)
  const [error, setError] = useState(false)
  const [lastGroupsSelected, setLastGroupsSelected] = useState(lastGroups)
  const [lastGroupsList, setLastGroupsList] = useState(lastGroups)

  const withNoGroup = useMemo(() => {
    return [
      {
        value: 0,
        label: intl.formatMessage({
          id: 'Load.SearchRecipients.nessunGruppo'
        })
      },
      ...groups
    ]
  }, [groups])

  const handleChange = selected => {
    setGroup(selected)
    setError(false)
  }

  const selectGroup = group => {
    setError(false)
    const listGroup = [
      {
        id: group.id,
        value: group.value,
        selected: true
      }
    ]

    lastGroupsSelected.map(g => {
      if (g.value !== group.value) {
        listGroup.push({
          id: g.id,
          value: g.value,
          selected: false
        })
      }
    })

    setLastGroupsSelected(listGroup)
    setGroup(group.id)
  }

  useEffect(() => {
    if (lastGroups && lastGroups.length > 0) {
      setLastGroupsSelected(lastGroups)

      const groupsList = []
      lastGroups.forEach(group => groupsList.push(group.id))
      setLastGroupsList(groupsList)

      const groups = lastGroups.filter(group => group.selected)
      if (groups && groups.length > 0) {
        setGroup(groups[0].id)
        initSearchRecipient(groups[0].id)
      }
    }
  }, [lastGroups])

  const searchRecipient = selectedGroup => {
    const groups = [selectedGroup]
    lastGroupsList.forEach(group => {
      if (selectedGroup !== group && groups.length < 3) {
        groups.push(group)
      }
    })

    setLastGroupsList(groups)

    searchRecipientsCallback(
      { includeGroups: [selectedGroup] },
      {
        lastGroups: [...groups],
        lastTypeSelected: 'group'
      },
      []
    ).then(res => {
      if (res.Items.length === 0) {
        setError(true)
      } else {
        setError(false)
      }
    })
  }

  const initSearchRecipient = selectedGroup => {
    searchRecipientsCallback({ includeGroups: [selectedGroup] }, null, []).then(
      res => {
        if (res.Items.length === 0) {
          setError(true)
        } else {
          setError(false)
        }
      }
    )
  }

  return (
    <>
      <Flex flexDirection='column' margin='0 0 8px 0'>
        <FlexItem margin='0 0 8px 0'>
          <Text>
            {intl.formatMessage(
              {
                id: 'Load.PreviewViewer.GroupSelection'
              },
              {
                strong: content => <strong key={content}>{content}</strong>
              }
            )}
          </Text>
        </FlexItem>

        <FlexItem>
          <Flex justifyContent='space-between'>
            <FlexItem width='75%'>
              <FormElement
                feedback={
                  error
                    ? intl.formatMessage({
                        id: 'Load.PreviewViewer.ErrorGroupRecipient'
                      })
                    : undefined
                }
                feedbackVariant={error ? 'danger' : undefined}
              >
                <Select
                  placeholder={intl.formatMessage({
                    id: 'Load.PreviewViewer.GroupSelectionPlaceholder'
                  })}
                  options={withNoGroup}
                  value={group}
                  onChange={handleChange}
                  error={error}
                />
              </FormElement>
            </FlexItem>

            <Button
              onClick={() => searchRecipient(group)}
              kind={BUTTON_VARIANT_PRIMARY}
              disabled={group === undefined}
            >
              {intl.formatMessage({ id: 'Load.Common.Apply' })}
            </Button>
          </Flex>
        </FlexItem>

        {lastGroupsSelected && lastGroupsSelected.length > 0 && (
          <Flex alignItems='baseline' margin='8px 0 0 0'>
            <FlexItem margin='0 16px 0 0'>
              <StyledLabel variant={TEXT_VARIANT_LIGHT}>
                {intl.formatMessage({
                  id: 'Load.PreviewViewer.LastSelected'
                })}
              </StyledLabel>
            </FlexItem>
            {lastGroupsSelected && (
              <Flex flexWrap='wrap'>
                {lastGroupsSelected.map(group => (
                  <FlexItem key={group.id} margin='0 8px 4px 0'>
                    <ChipCheckbox
                      onChange={() => selectGroup(group)}
                      label={group.value}
                      checked={group.selected}
                    />
                  </FlexItem>
                ))}
              </Flex>
            )}
          </Flex>
        )}
      </Flex>
    </>
  )
}

SelectGroup.defaultProps = {
  groups: [],
  lastGroups: []
}

SelectGroup.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object),
  lastGroups: PropTypes.arrayOf(PropTypes.object),
  searchRecipientsCallback: PropTypes.func
}
